import { render } from "./CommissionsPage.vue?vue&type=template&id=2e1156b9&scoped=true"
import script from "./CommissionsPage.vue?vue&type=script&lang=js"
export * from "./CommissionsPage.vue?vue&type=script&lang=js"

import "./CommissionsPage.vue?vue&type=style&index=0&id=2e1156b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1156b9"]])

export default __exports__